/* eslint-disable class-methods-use-this */
import BlockedSlot from '../types/model/BlockedSlot';
import service from '../services/RestService';
import AbstractRestRepository from './AbstractRestRepository';

export default class BlockedSlotRepository extends AbstractRestRepository<BlockedSlot> {
  async getAll(params: { projectId: number; startDate?: string; endDate?: string }): Promise<BlockedSlot[]> {
    const responseBlocked = await service.get(`/booking/blocked?projectId=${params.projectId}`);
    const responseBlockedDays = await service.get(`/booking/blocked-days?projectId=${params.projectId}`);

    const blockedSlots: BlockedSlot[] = super.unpackResponseContent(responseBlocked) ?? [];
    const blockedSlotsDays: string[] = super.unpackResponseContent(responseBlockedDays) ?? [];
    return {
      ...blockedSlots.map((slot) => ({
        ...slot,
        id: `${params.projectId}_${slot.blockedDay}_${slot.timeSlot}`,
        projectId: params.projectId,
        blockedAllDay: blockedSlotsDays.includes(slot.blockedDay)
      }))
    };
  }
}
